import { createSelector } from '@ngrx/store'
import { AppState } from '../../app.state'
import { FullState } from './fullList.reducer';


export const selectFullSlice = (state: AppState) => state.fullSlice;



export const selectedFull = createSelector(
    selectFullSlice,
    (state: FullState) => {
        return state.selectedFullUUID
    }
)


export const selectFullItemList = createSelector(
    selectFullSlice,
    (state: FullState) => {
        return state.itemList
    }
)
